<template>
  <div :class="hideTitle ? 'd-flex justify-end' : 'd-flex justify-space-between'">
    <div v-if="!hideTitle" class="filter-title">Filtros</div>

    <div class="d-flex align-center">
      <div v-if="!hideSwitch" class="d-flex">
        <AGSwitch
          v-for="item in switches"
          :id="item.id"
          :key="item.id"
          v-model="item.value"
          :disabled="item.disabled"
          :label="item.label"
          :name="item.id + '_name'"
          @update:model-value="toggleSwitch(item)"
        />
      </div>

      <AGButton :id="idToAttach" left-icon="md:filter_alt" type="secondary" :disabled="disabled">
        Filtro {{ filterSelectedCounter }}
      </AGButton>

      <v-menu
        v-model="menuActive"
        location="bottom left"
        width="384px"
        z-index="4"
        :height="heightDialog"
        :activator="'#' + idToAttach"
        :persistent="false"
        :close-on-content-click="false"
      >
        <v-card class="filter-dropdown">
          <div class="d-flex flex-row justify-space-between filter-dropdown-header">
            <strong class="filter-title"> Filtro </strong>
            <AGIcon icon="md:close" @click="closeFilterDialog()" />
          </div>

          <div class="filters-dropdown-content">
            <slot name="filters" />
          </div>

          <div class="filters-buttons-container">
            <div class="btn-apply-filter">
              <AGButton type="primary" :disabled="disableApply" @click="applyFilter()"> Aplicar </AGButton>
            </div>
            <div class="btn-clear-filter">
              <AGButton
                left-icon="mdi-delete-outline"
                type="secondary"
                :disabled="!hasFilterSelected"
                @click="clearFilters()"
              >
                Limpar filtro
              </AGButton>
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
import AGButton from '@/components/common/AGButton.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import AGSwitch from '@/components/common/AGSwitch.vue';
import { isEmpty, isEqual, uniqueId } from 'lodash';

export default {
  components: {
    AGSwitch,
    AGIcon,
    AGButton,
  },

  emits: ['toggleSwitch', 'closeFilterDialog', 'applyFilter', 'clearFilters'],

  props: {
    modelValue: {
      type: Object,
      required: true,
    },

    hideTitle: {
      type: Boolean,
      default: false,
    },

    switches: {
      type: Array,
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    disabledFilterApplyBtn: {
      type: Boolean,
      default: false,
    },

    heightDialog: {
      type: String,
      default: '650px',
    },

    filterState: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    return {
      switchesData: [],
      menuActive: false,
      filterApplied: false,
    };
  },

  computed: {
    counter() {
      return Object.values(this.modelValue).filter((value) => {
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') return !isEmpty(value);

        return !!value;
      }).length;
    },

    hideSwitch() {
      return this.switches?.length <= 0;
    },

    hasFilterSelected() {
      return this.counter > 0;
    },

    filterSelectedCounter() {
      return this.hasFilterSelected ? `(${this.counter})` : '';
    },

    idToAttach() {
      return uniqueId('open_filter_btn_');
    },

    disableApply() {
      return this.disabledFilterApplyBtn || (this.filterState ? isEqual(this.modelValue, this.filterState) : false);
    },
  },

  watch: {
    menuActive(val) {
      if (val) return;

      if (this.filterApplied) {
        this.filterApplied = false;
        return;
      }

      this.$emit('closeFilterDialog');
    },
  },

  created() {
    if (import.meta.env.NODE_ENV === 'development') {
      console.warn(
        '⚠️⚠️⚠️⚠️[Deprecation Warning]⚠️⚠️⚠️⚠️ - O componente FilterEncapsulated está em processo de depreciação e será removido em uma versão futura do agnes. Por favor, use o componente AGFilter em seu lugar.',
      );
    }
  },

  methods: {
    toggleSwitch(item) {
      this.$emit('toggleSwitch', item);
    },

    closeFilterDialog() {
      this.menuActive = false;
      this.filterApplied = false;
    },

    applyFilter() {
      this.filterApplied = true;
      this.$emit('applyFilter');
      this.menuActive = false;
    },

    clearFilters() {
      this.$emit('clearFilters');
    },
  },
};
</script>

<style scoped lang="scss">
.v-card {
  padding: 0 !important;
}

.filter-title {
  font-size: $font-size-sm;
  font-weight: $font-weight-bold;
}

.filter-dropdown {
  padding: $spacing-05;
  height: fit-content;
  overflow-y: hidden !important;
  display: flex;
  flex-direction: column;

  .filter-dropdown-header {
    border-bottom: $border-width-hairline $border-default rgb(var(--v-theme-primaryLight));
    padding: $spacing-inset-05;

    .v-icon {
      cursor: pointer;
    }
  }

  .filters-dropdown-content {
    overflow-y: auto;
    padding: $spacing-inset-05;
    display: flex;
    flex-direction: column;
    gap: $spacing-05;
    flex: 1;

    ::v-deep(div:nth-child(1)) {
      padding-top: 0 !important;
    }
  }

  .filters-buttons-container {
    padding: 0 $spacing-inset-05 $spacing-inset-05 $spacing-inset-05;
    .v-btn {
      letter-spacing: 0.16px;
    }
    .btn-apply-filter {
      padding-top: $spacing-05;
      padding-bottom: $spacing-05;

      .v-btn {
        width: 100% !important;
      }
    }

    .btn-clear-filter {
      .v-btn {
        width: 100% !important;
      }
    }
  }
}

.filter-chip {
  margin: $spacing-03 0 $spacing-03 $spacing-03;
}
</style>
